import React from "react";
import { BrowserRouter } from "react-router-dom";
import FamilyVault from "./FamilyVault";
export default function App() {
  return (
    <BrowserRouter>
      <FamilyVault />
    </BrowserRouter>
  );
}
